// extracted by mini-css-extract-plugin
export default {"contentWrapper":"MyUser_contentWrapper__93TnW"};